import React from 'react';
import {
  RadialBarChart,
  RadialBar,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

interface RadialChartData {
  name: string;
  value: number;
  fill: string;
}

interface RadialChartComponentProps {
  data: RadialChartData[];
  height?: number;
  title?: string;
}

const RadialChartComponent: React.FC<RadialChartComponentProps> = ({
  data,
  height = 400,
  title,
}) => {
  return (
    <div className="bg-panel rounded-lg shadow p-6">
      {title && (
        <h3 className="text-lg font-semibold text-heading mb-4">
          {title}
        </h3>
      )}
      <ResponsiveContainer width="100%" height={height}>
        <RadialBarChart
          cx="50%"
          cy="50%"
          innerRadius="10%"
          outerRadius="90%"
          barSize={20}
          data={data}
        >
          <RadialBar
            label={{ position: 'insideStart', fill: '#fff' }}
            background
            dataKey="value"
          />
          <Legend
            iconSize={10}
            layout="vertical"
            verticalAlign="middle"
            align="right"
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'rgb(31 41 55)',
              border: 'none',
              borderRadius: '0.5rem',
              color: 'white',
            }}
          />
        </RadialBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadialChartComponent;
